import { Modal, Button } from 'react-bootstrap';
import { variables } from "../Variables";

import closeIcon from '../assets/images/cross-close.svg';
import { useDispatch, useSelector } from 'react-redux';
import { setShowHistoryTabModal } from '../features/ShowHistoryTabSlice';
import { HistoryActionLogs } from './HistoryActionLogs';

export const HistoryTabModal = ({ estate }) => {

    const reduxHistoryTabModal = useSelector(state => state.showHistoryTabModal.showHistoryTabModal);
    const dispatch = useDispatch();

    const handlerCloseModel = () => {
        dispatch(setShowHistoryTabModal(false));
    }

    return (
        <>
            <Modal show={reduxHistoryTabModal} onHide={handlerCloseModel} className="contactWaitingListModal modalStyle p-0">
                <Modal.Body className="p-0">
                    <div className="modal-container">
                        <div className="d-flex justify-content-end mb-3">
                            <img src={closeIcon} onClick={handlerCloseModel} className="cursor-pointer" />
                        </div>
                        <HistoryActionLogs estate={estate} />
                    </div>
                </Modal.Body>
            </Modal>
        </>
    )

}